export const POST = `
	query post($id: Uint) {
		post(id: $id) {
			id
			attendee {
				id
				email
				first_name
				last_name
				avatar_url
			}
			body
			likes
			approved
			published
			pinned
			created_at
			comments {
				nodes {
					id
					attendee {
						id
						email
					}
					body
				}
			}
			attendees_who_liked {
				nodes {
						id
						avatar_url
						first_name
						last_name
				}
			}
			media {
				nodes {
					id
					name
					src
					mime_type
				}
			}
		}
	}
`;

export const POSTS = `
	query posts($event_id: Uint, $offset: Uint, $items_per_page: Uint) {
		posts(event_id: $event_id, offset: $offset, items_per_page: $items_per_page) {
			nodes {
				id
				attendee {
					id
					email
				}
				body
				likes
				created_at
				pinned
				comments {
					nodes {
						id
					}
				}
				attendees_who_liked {
					nodes {
						id
						avatar_url
						first_name
						last_name
					}
				}
				media {
					nodes {
						id
						name
						src
						mime_type
					}
				}
			}
			page_info {
				total_count
				has_next_page
			}
			total_media_count
		}
	}
`;
